import React, { useContext } from "react";
import { GlobalContext } from "../../contexts/GlobalContext";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import PageTitle from "../../components/PageTitle/PageTitle";
import Btn from "../../components/Btn/Btn";
import Divider from "../../components/Divider/Divider";
import "./Press.css";
import CardContactMkt from "../../components/CardContactMkt/CardContactMkt";

const Press = () => {
  const { state } = useContext(GlobalContext);
  const language = state.language || "pt-br";
  const data = require(`../../assets/languages/${language}/press.json`);
  const {
    breadcrumb,
    pageTitle,
    selectedPage,
    pressNumber,
    pressMessageNumber,
    urlApi,
  } = data;

  const handleClick = () => {
    const whatsappUrl = `${urlApi}${pressNumber}?text=${encodeURIComponent(pressMessageNumber)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      <Breadcrumb beforeRoutes={breadcrumb} selectedPage={selectedPage} />

      <div className="main-container mg-bot-100">
        <section className="section-container">
          <PageTitle title={pageTitle} />
          <CardContactMkt activeContent />
        </section>
      </div>
    </>
  );
};

export default Press;
